import { useTranslation } from 'react-i18next';
import { KoobTableAction } from '@koob/ui';
import { openTripWizard } from '@koob/ui/src/features/tripWizard';
import { useHydrateTrip } from '../../TripDesigner/Compose/useHydrateTrip';

const FoldersTripDraftEditButton = ({ tripId }) => {
  const { t } = useTranslation();
  const hydrateTrip = useHydrateTrip();

  // Open the settings modal in place over the folder rather than routing to
  // /design-trip — saving redirects to the composer (wizard onSaved), so
  // there's no intermediate URL to get stuck on.
  const handleEdit = async () => {
    await hydrateTrip(tripId, { fromDraft: true });
    openTripWizard('edit');
  };

  return (
    <KoobTableAction icon="edit" label={t('misc:edit')} onClick={handleEdit} />
  );
};

export default FoldersTripDraftEditButton;
